import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  MobileCommonBack,
  WebAdmin1,
  WebAdmin2,
  MobileAdmin3,
  MobileAdmin4,
} from '../../../assets/web';

const T = {
  Wrapper: styled.article`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  `,
  Img: styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    background: url(${MobileCommonBack});
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: contain;
  `,
  Title: styled.div`
    margin-top: 100px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  TitleText: styled.div`
    font-size: 16px;
    color: ${({ theme }) => `${theme.blue}`};
    margin-bottom: 20px;

    &.desc {
      color: #000;
      font-size: 24px;
      margin: 0;
      line-height: 36px;
    }

    &.margin {
      margin-bottom: 30px;
    }
  `,
};

const List = {
  W: styled.ul`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 420px;
    min-width: 340px;
    padding: 0 30px;
    margin-bottom: 200px;
  `,
  ItemLine: styled.li`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
  `,
  Item: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 400px;
  `,
  Img: styled.img`
    object-fit: contain;
    width: 110px;
    height: auto;
    margin-bottom: 10px;
  `,
  Title: styled.div`
    color: ${({ theme }) => `${theme.blue}`};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 18px;
    font-size: 14px;

    position: absolute;
    top: 70px;

    &.one {
      top: 63px;
    }
  `,
  Desc: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    opacity: 0.7;
    line-height: 20px;
    font-size: 12px;
    word-spacing: -2px;
    white-space: nowrap;
  `,
  Text: styled.div``,
};

const MobileAdmin: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <T.Wrapper id="m_p6">
      <T.Title>
        <T.TitleText>{t('admin_title')}</T.TitleText>
        <T.TitleText className="desc">{t('admin_title_2_mobile_1')}</T.TitleText>
        <T.TitleText className="desc margin">{t('admin_title_2_mobile_2')}</T.TitleText>
      </T.Title>
      <List.W>
        <List.ItemLine>
          <List.Item>
            <List.Img src={WebAdmin1} />
            <List.Title className={i18n.language === 'en-US' ? 'one' : ''}>
              <List.Text>{t('admin_1_title')}</List.Text>
              <List.Text>{t('admin_1_title_2')}</List.Text>
            </List.Title>
            <List.Desc>
              <List.Text>{t('admin_1_1')}</List.Text>
              <List.Text>{t('admin_1_2')}</List.Text>
              <List.Text>{t('admin_1_3')}</List.Text>
            </List.Desc>
          </List.Item>
          <List.Item>
            <List.Img src={WebAdmin2} />
            <List.Title>
              <List.Text>{t('admin_2_title')}</List.Text>
            </List.Title>
            <List.Desc>
              <List.Text>{t('admin_2_1')}</List.Text>
              <List.Text>{t('admin_2_2')}</List.Text>
              <List.Text>{t('admin_2_3')}</List.Text>
              <List.Text>{t('admin_2_4')}</List.Text>
            </List.Desc>
          </List.Item>
        </List.ItemLine>
        <List.ItemLine>
          <List.Item>
            <List.Img src={MobileAdmin3} />
            <List.Title>
              <List.Text>{t('admin_3_title')}</List.Text>
            </List.Title>
            <List.Desc>
              <List.Text>{t('admin_3_1')}</List.Text>
              <List.Text>{t('admin_3_2')}</List.Text>
            </List.Desc>
          </List.Item>
          <List.Item>
            <List.Img src={MobileAdmin4} />
            <List.Title className="one">
              <List.Text>{t('admin_4_title')}</List.Text>
              <List.Text>{t('admin_4_title_2')}</List.Text>
            </List.Title>
            <List.Desc>
              <List.Text>{t('admin_4_1')}</List.Text>
              <List.Text>{t('admin_4_2')}</List.Text>
            </List.Desc>
          </List.Item>
        </List.ItemLine>
      </List.W>
      <T.Img />
    </T.Wrapper>
  );
};

export default MobileAdmin;
